import enUS from "@evercam/shared/i18n/enUS"

export default enUS
